import React from 'react';
import { Switch, Route } from 'react-router-dom';
import useApp from '../store/app/appContext';
import AdminRoute from './AdminRoute';
import LoginPage from '../pages/app/LoginPage';
import RegisterPage from '../pages/app/RegisterPage';
import HomePage from '../pages/app/HomePage';
import AccountPage from '../pages/app/AccountPage';
import TreatmentDetailsPage from '../pages/app/TreatmentDetailsPage';
import ScansPage from '../pages/app/ScansPage';
import InvoicesPage from '../pages/app/InvoicesPage';
import MyAppointmentsPage from '../pages/app/MyAppointmentsPage';
import AppointmentDetails from '../pages/app/AppointmentDetails';
import PatientManagerPage from '../pages/app/PatientManagerPage';
import ClinicManagerPage from '../pages/app/ClinicManagerPage';
import PartnerManagerPage from '../pages/app/PartnerManagerPage';
import StaffManagerPage from '../pages/app/StaffManagerPage';
import TreatmentManagerPage from '../pages/app/TreatmentManagerPage';
import PatientDetails from '../pages/app/PatientDetails';
import PartnerDetails from '../pages/app/PartnerDetails';
import StaffDetails from '../pages/app/StaffDetails';
import RouterRedirect from './RouterRedirect';
import LoginRedirect from '../containers/app/LoginRedirect';
import TreatmentTransactionPaymentCheckout from '../pages/app/CheckoutPage';
import UpdatePasswordPage from '../pages/app/UpdatePasswordPage';
import ClinicDetails from '../pages/app/ClinicDetails';
import AddTreatmentPage from '../pages/app/AddTreatmentPage';
import InvoiceDetails from '../pages/app/InvoiceDetails';
import PrivateRoute from './PrivateRoute';
import PatientOrPartnerRoute from './PatientOrPartnerRoute';
import PatientRoute from './PatientRoute';
import PartnerRoute from './PartnerRoute';
import LandingPagePro from '../pages/landingPage/LandingPagePro';
import LandingPagePatient from '../pages/landingPage/LandingPagePatient';
import ScheduleScanAndGo from '../pages/landingPage/ScheduleScanAndGo';
import AboutUs from '../pages/landingPage/AboutUs';
import PatientScans from '../pages/app/PatientScans';
import PatientScansDetails from '../pages/app/PatientScanDetails';
import STLViewerPage from '../pages/app/STLViewer';
import Careers from '../pages/landingPage/Careers';
import BecomeAPartner from '../pages/landingPage/BecomeAPartner';
import VerifyAccount from '../containers/app/VerifyAccount';

require('dotenv').config();

function App() {

  const { appState: { isAuthenticated } } = useApp();

  if (!isAuthenticated) return (
    <Switch>
      <Route component={LoginPage} path='/login'/>
      <Route component={RegisterPage} path='/register'/>
      <Route component={LoginRedirect} path='/auth/redirect/:token' />
      <Route component={LandingPagePro} path="/professional" exact/>
      <Route component={LandingPagePatient} path="/patient" exact />
      <Route component={AboutUs} path={["/professional/about-us", '/patient/about-us']} exact />
      <Route component={Careers} path={["/professional/careers", "/patient/careers"]} exact />
      <Route component={BecomeAPartner} path={["/professional/become-a-partner"]} exact />
      <Route component={VerifyAccount} path={"/verify-account/:token"} exact/>
      <Route component={RouterRedirect} path='/'/>
    </Switch>
  ) 
  
  return (
    <Switch>
      <PrivateRoute component={LandingPagePro} path="/professional" exact/>
      <PrivateRoute component={LandingPagePatient} path="/patient" exact />
      <PrivateRoute component={ScheduleScanAndGo} path="/scanandgo" />
      <PrivateRoute component={AboutUs} path={["/professional/about-us", '/patient/about-us']} exact />
      <PrivateRoute component={Careers} path={["/professional/careers", "/patient/careers"]} exact />
      <PrivateRoute component={BecomeAPartner} path={["/professional/become-a-partner"]} exact />
      <PrivateRoute component={HomePage} path='/dashboard'/>
      <PrivateRoute component={AccountPage} path='/account'/>
      
      <PrivateRoute component={UpdatePasswordPage} path='/update-password'/>
      <PartnerRoute component={InvoicesPage} path='/my-invoices' exact/>
      <PartnerRoute component={InvoiceDetails} path={['/my-invoices/add', '/my-invoices/:id']}/>
      
      <PatientRoute component={ScansPage} path='/my-scans' exact/>
      <PatientRoute component={PatientScansDetails} path={['/my-scans/:patientId/add-scan', '/my-scans/:patientId/scan-details/:id']}/>
      <PrivateRoute component={STLViewerPage} path='/stl-viewer/:scanId/:scanName'/>

      <PatientRoute component={TreatmentTransactionPaymentCheckout} path='/my-treatments/checkout'/>   
      
      <PatientOrPartnerRoute component={MyAppointmentsPage} path='/my-appointments' exact/>
      <PatientOrPartnerRoute component={AppointmentDetails} path={'/my-appointments/:id'}/>
      <PrivateRoute component={AppointmentDetails} path={'/appointments/:id'}/>

      <PatientOrPartnerRoute component={TreatmentManagerPage} path='/my-treatments' exact/>
      <PatientOrPartnerRoute component={TreatmentDetailsPage} path='/my-treatments/details' />
      <PartnerRoute component={AddTreatmentPage} path='/my-treatments/add'/>

      <AdminRoute component={PatientManagerPage} path='/manage-patients' exact/>
      <PrivateRoute component={PatientScans}  path={'/manage-patients/scans/:id'} exact/>
      <PrivateRoute component={PatientScansDetails} path={['/manage-patients/:patientId/add-scan', '/manage-patients/:patientId/scan-details/:id']}/>
      <AdminRoute component={PatientDetails}  path={['/manage-patients/add', '/manage-patients/:id']}/>
      <AdminRoute component={PartnerManagerPage} path='/manage-partners' exact/>
      <AdminRoute component={PartnerDetails}  path={['/manage-partners/add', '/manage-partners/:id']}/>
      <AdminRoute component={ClinicManagerPage} path='/manage-clinics' exact/>
      <AdminRoute component={ClinicDetails}  path={['/manage-clinics/add', '/manage-clinics/:id']}/>
      <AdminRoute component={StaffManagerPage} path='/manage-staff' exact/>
      <AdminRoute component={StaffDetails}  path={['/manage-staff/add', '/manage-staff/:id']}/>
      <AdminRoute component={InvoicesPage} path='/manage-invoices' exact/>
      <AdminRoute component={InvoiceDetails} path={'/manage-invoices/:id'}/>
      <AdminRoute component={TreatmentManagerPage} path='/manage-treatments' exact/>
      <AdminRoute component={AddTreatmentPage} path='/manage-treatments/add'/>
      <AdminRoute component={TreatmentDetailsPage} path='/manage-treatments/details' />
      
      <PrivateRoute component={VerifyAccount} path={"/verify-account/:token"} exact/>
      <PrivateRoute component={RouterRedirect} path='/'/>  
    </Switch>
  );
}

export default App;
